// Спільний X-App-Token обох кабінетів (citynet + langate). Ingress-ґейт /api/* без нього
// віддає 403 ще до бекенду. Один токен на обидва бренди — єдине джерело правди: клієнт
// ставить його в setConfig-header.
const APP_TOKEN = '2W8tJt9Tan49XfvapcZ57CRmZlcAa3wcZfqy+/HfwyA='

export default APP_TOKEN
